import React from "react";

const Sectors = ({ name, className = "", style }) => {
  return (
    <div
      className={`w-auto h-auto flex items-center justify-center text-font-xs cursor-pointer
                 bg-primary-nav text-text-primary py-2 px-4 rounded-border-radius-md 
                 text-center text-xs font-semibold transition-colors duration-200 delay-200 
                 hover:bg-hover-bg-white-light ${className}`}
      style={style}
    >
      {name}
    </div>
  );
};

export default Sectors;
